module.exports = __webpack_public_path__ + "img/pen-size-4.25638ddc.svg";